/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2026-04-21 12:22:36
 * @Description: file content
 */
import Vue from "vue";
// import Base64 from "@/js/util/base64";
import K from "@/js/util/loca_key";
import i18n from "@/i18n";
import moment from "moment";
import AES from "@/js/util/AES";
import store from "@/store/index";
import decimal from "./decimal";

import {
  getSeo,
  joinBrand,
  memberSetting,
  getCountry,
  getResourceInfo,
  getImageConfig,
} from "@/js/api/system/api";
import {
  queryDeliveryFee,
  addFoodRedis,
  getFoodRedis,
  clearFoodRedis,
  getShop,
  getRestaurantInfoAtlas,
} from "@/js/api/restaurant/api";
import { getSignature, ossUploadImg } from "@/js/api/member/api";

import { getMemberOrderList } from "@/js/api/order/api";

let util = {
  /**
   * 獲取用戶標識 -- 隨機數
   * @param {boolean} randomFlag
   * @param {number} min
   * @param {number} max
   */
  randomWord(randomFlag, min, max) {
    let str = "",
      range = min,
      arr = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];

    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (let i = 0; i < range; i++) {
      let pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  },
  /**
   * 獲取用戶 token
   * @returns
   */
  getToken() {
    // * 獲取緩存中的
    // ? 之所以不用 fp 來獲取比較穩定的用戶信息, 是因為 掃碼點餐如果出現未結賬, 用戶可以通過無痕模式來重新生成 token, 達到點餐的目的
    let rw = localStorage.getItem(K.random_word);
    // 如果沒得
    if (util.isNull(rw)) {
      // 生成
      rw = util.randomWord(true, 24, 48);
      // 存入緩存
      localStorage.setItem(K.random_word, rw);
    }
    return rw;
  },
  // 登錄 token
  token: {
    /**
     * 獲取token
     * @returns
     */
    get() {
      // 獲取緩存中的
      let token = localStorage.getItem("user_token");
      let uid = localStorage.getItem(K.user_id);
      if (token && uid) {
        return AES.encrypt(`7_${uid}_${new Date().getTime()}_${token}`);
      }
      // else if (uid && !token) {
      //   // 登出
      //   localStorage.removeItem("user_token");
      //   localStorage.removeItem(K.user_id);
      //   localStorage.removeItem(K.user_phone);
      // }
      return "";
    },
    /**
     * 設置token
     * @param {string} token
     */
    set(token) {
      localStorage.setItem("user_token", token);
    },
  },
  /**
   * 設置系統信息
   */
  setSystemTheme() {
    // 查詢系統顏色
    memberSetting({
      settingSection: "API",
      settingName: "App_Theme_Color",
    })
      .then((res) => {
        if (res.success) {
          let data = res.data;
          this.setThemeColor(data.valueChar, "t");
        }
      })
      .catch((err) => {
        this.setThemeColor("", "t");
      });
    // 查詢 城市
    getCountry()
      .then((res) => {
        if (res.success) {
          let country = res.data;
          if (country) {
            Vue.prototype.country = country;
          }
        }
      })
      .catch((err) => {});

    // getSysSetting({
    //   settingSection: "API",
    //   settingName: ""
    // }).then(res => {
    //   if (res.code == "1") {
    //     let country = res.country;
    //     if (country) {
    //       Vue.prototype.country = country;
    //     }
    //     let data = res.data;
    //     if (data) {
    //       for (let i = 0; i < data.length; i++) {
    //         if (data[i].settingName == "App_Theme_Color") {
    //           let value = data[i].valueChar;
    //           this.setThemeColor(value, "t");
    //           break;
    //         }
    //       }
    //     }
    //   }
    // });
  },
  // 查詢 區域, 設置全局區域
  getCountryFun() {
    // 拿到緩存
    let countryStr = localStorage.getItem(K.country_key);
    if (countryStr) {
      Vue.prototype.country = JSON.parse(countryStr);
    }
    // 查詢 城市
    getCountry()
      .then((res) => {
        if (res.success) {
          let country = res.data;
          if (country) {
            Vue.prototype.country = country;
            // 替換緩存
            localStorage.setItem(K.country_key, JSON.stringify(country));
          }
        }
      })
      .catch((err) => {});
  },
  /**
   * 設置主題色
   * @param {string} rgb 0,0,0
   * @param {*} t 判斷依據
   */
  setThemeColor(rgb = "190,28,66", t) {
    // 如果是 clinkpos 域名, 則全部為黑色主題
    if (location.origin.indexOf("clinkpos.com") > -1) {
      rgb = "0,0,0";
    }
    if (rgb) rgb = rgb.replace("rgb(", "").replace(")", "");
    if (t) {
      if (localStorage.getItem(K.theme_color)) {
        rgb = localStorage.getItem(K.theme_color);
      }
    }
    // 判斷 rgb 是否合理 不合理 設置默認值
    try {
      let rgbArr = rgb.split(",");
      if (rgbArr.length == 4) {
        rgbArr.splice(3, 1);
        rgb = rgbArr.join(",");
      } else if (rgbArr.length != 3) {
        rgb = "190,28,66";
      }
    } catch (error) {
      rgb = "190,28,66";
    }

    if (!rgb) {
      return;
    } else {
      localStorage.setItem(K.theme_color, rgb);
    }

    let R = `rgb(${rgb})`;
    let hex = util.rgbToHex(rgb);
    Vue.prototype.ThemeColor = R;
    let R5 = `rgba(${rgb},0.5)`;
    util.setRootColor("--themeColor", R);
    util.setRootColor("--themeColor1", `rgba(${rgb},0.1)`);
    util.setRootColor("--themeColor2", `rgba(${rgb},0.2)`);
    util.setRootColor("--themeColor3", `rgba(${rgb},0.3)`);
    util.setRootColor("--themeColor4", `rgba(${rgb},0.4)`);
    util.setRootColor("--themeColor5", `rgba(${rgb},0.5)`);
    util.setRootColor("--themeColor6", `rgba(${rgb},0.6)`);
    util.setRootColor("--themeColor7", `rgba(${rgb},0.7)`);
    util.setRootColor("--themeColor8", `rgba(${rgb},0.8)`);
    util.setRootColor("--themeColor9", `rgba(${rgb},0.9)`);
    let R2 = `rgba(${rgb},0.2)`;
    if (document.querySelector("#self_style")) {
      document.querySelector("#self_style").remove();
    }
    let style_ = document.createElement("style");
    style_.id = "self_style";

    // 清除旧的主题相关 meta 标签
    const metaNames = [
      "theme-color",
      "apple-mobile-web-app-status-bar-style",
      "msapplication-navbutton-color",
      "msapplication-TileColor",
      "apple-mobile-web-app-capable",
    ];
    metaNames.forEach((name) => {
      const meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) meta.remove();
    });

    // 基础 theme-color
    let themeMeta = document.createElement("meta");
    themeMeta.setAttribute("name", "theme-color");
    themeMeta.setAttribute("content", R);
    document.head.appendChild(themeMeta);

    // Safari (iOS) 支持
    let safariMeta = document.createElement("meta");
    safariMeta.setAttribute("name", "apple-mobile-web-app-status-bar-style");
    safariMeta.setAttribute("content", "black-translucent");
    document.head.appendChild(safariMeta);

    // PWA 支持
    let pwaMeta = document.createElement("meta");
    pwaMeta.setAttribute("name", "apple-mobile-web-app-capable");
    pwaMeta.setAttribute("content", "yes");
    document.head.appendChild(pwaMeta);

    // Windows 支持
    let msMeta1 = document.createElement("meta");
    msMeta1.setAttribute("name", "msapplication-navbutton-color");
    msMeta1.setAttribute("content", R);
    document.head.appendChild(msMeta1);

    let msMeta2 = document.createElement("meta");
    msMeta2.setAttribute("name", "msapplication-TileColor");
    msMeta2.setAttribute("content", hex);
    document.head.appendChild(msMeta2);

    // 生成 CSS 变量和样式
    let css_ = `
          .theme_bg_color,
          .scanTable-stepper .van-stepper__plus,
          .scan-person .van-button--default{background-color:${R} !important;}
          .theme_color,
          .scanTable-stepper .van-stepper__minus{color:${R} !important;}
          .theme_border_color,
          .scanTable-stepper .van-stepper__minus{border-color:${R} !important;}
          .theme_border_top_color{border-top-color:${R} !important;}
          .theme_border_right_color{border-right-color:${R} !important;}
          .theme_border_bottom_color{border-bottom-color:${R} !important;}
          .theme_border_left_color{border-left-color:${R} !important;}
          .theme_bg_color_5{ background-color:${R5} !important;}
          .theme_bg_color_2{ background-color:${R2} !important;}

          .van-radio__icon--checked .van-icon,
          .van-button--primary,
          .van-checkbox__icon--checked .van-icon{background-color:${R} !important; border-color:${R} !important;}
          .app_index .van-tabs__line,.van-badge,.app_reservation_box .van-tabs__line{background-color:${R} !important;}

          .self_body .self_tabs .van-tab--active{color:${R} !important;}
          .app_reservation_box .van-tab--active{color:${R} !important;}
          .notice_tabs .van-tabs__nav,.notice_tabs .van-tab--active{border-radius:8px;}
          .notice_tabs .van-tabs__nav--card .van-tab{border-right:none;}
          .notice_tabs .van-tabs__wrap{position:fixed;width:100%;background-color: rgb(242,242,242);z-index:10;padding:5px 0;}
          .notice_title_icon .van-badge{background-color:rgb(204,26,78) !important;left:-4px;top:4px;right:auto;}
          .add_address .isdefault.van-switch--on{background-color:${R} !important;}
          .resources_agree .van-checkbox__icon .van-icon{border-color:#9c9292;}
          .tagContent .van-tab--active .van-tab__text{background-color:${R} !important;}
          .el-dropdown-menu__item:not(.is-disabled):hover {background-color: ${R2};color: ${R};}
          .menu-box .group-box .item .badeg .el-badge__content{background-color:${R} !important;}
          .pc-el-confirm .el-message-box__btns .el-button:nth-of-type(1):hover{background-color: ${R2};color: ${R};border-color:${R} !important;}
          .pc-el-confirm .el-message-box__btns .el-button:nth-of-type(2){background-color: ${R};border-color:${R} !important;}
          .pc-el-alert .el-message-box__btns .el-button:nth-of-type(1){background-color: ${R};border-color:${R} !important;}
          .el-loading-spinner .path{stroke:${R};}
          .theme_bg_color.is-disabled{background-color:${R2} !important;}
          .theme_border_color.is-disabled{border-color:${R2} !important;}
          .el-checkbox__inner:hover{border-color:${R} !important;}
          .el-checkbox__input.is-checked .el-checkbox__inner{border-color:${R} !important;background-color:${R} !important;}
          .el-checkbox__input.is-focus .el-checkbox__inner{border-color:${R} !important;}
          .el-checkbox__input.is-checked+.el-checkbox__label{color:${R} !important;}
          .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:${R} !important;}
          .el-pagination.is-background .el-pager li:not(.disabled):hover{color:${R} !important;}
          .el-input__inner:focus{border-color:${R} !important;}
          .van-button.van-button--default.van-button--large.van-dialog__confirm{color:${R}}
        `;
    style_.textContent = css_;
    document.head.append(style_);
  },
  /**
   * 将 RGB 转换为十六进制颜色
   * @param {string} rgb 0,0,0
   * @returns {string} #RRGGBB
   */
  rgbToHex(rgb) {
    const rgbArr = rgb.split(",").map(Number);
    return (
      "#" +
      rgbArr
        .map((num) => {
          const hex = num.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  },
  /**
   * 將 內容轉為字符串, 判斷是否為空
   * @param {*} obj
   */
  isNull(obj) {
    obj = obj + "";
    if (
      obj == null ||
      obj == undefined ||
      obj == "" ||
      obj == "NaN" ||
      obj == "undefined" ||
      obj == "null"
    ) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 判斷是否為空, 並返回值
   * @param {*} obj
   * @param {*} t
   */
  ifNull(obj, t) {
    if (this.isNull(obj)) {
      return t;
    }
    return obj;
  },
  /**
   * 獲取 window 寬高
   */
  getWindowInner() {
    let J = {};
    let w = document.body.clientWidth; // window.innerWidth; //用這玩意, 在 蘋果微信裡面, 經過 qrcode.html 轉發後, 第一次打開食品圖片巨大.... 所以改了
    let h = window.innerHeight;
    if (this.IsPC()) {
      J.w = w;
      J.h = h;
      // J.w = 375;
      // J.h = 637; // 應該是 657 , 這裡和 app.vue 中的一致, 但是多了個 頂部img , 高度是20 , 所以這裡減掉
      // if (h < 665) {
      //   J.h = h - 30;
      // }
    } else {
      // 橫屏 就 寬就是高
      let orientation = window.orientation;
      if (w > h && orientation != 0) {
        let a = w;
        w = h;
        h = a;
      }
      J.w = w;
      J.h = h;
    }
    return J;
  },
  /**
   * 獲取 帶 ***** 的手機號碼
   */
  getStarPhone(appUserPhone = "") {
    if (!appUserPhone) appUserPhone = localStorage.getItem(K.user_phone);
    const isWeChat =
      /MicroMessenger/i.test(navigator.userAgent) || // 移动端微信
      /WindowsWechat/i.test(navigator.userAgent); // PC端微信
    if (isWeChat && (appUserPhone == "undefined" || !appUserPhone)) {
      return "微信已登入";
    }
    if (appUserPhone) {
      let phone = appUserPhone + "";
      let p = "";
      if (phone.length == 11) {
        return phone.substring(0, 3) + "****" + phone.substring(7, 11);
      } else {
        for (let i = 0; i < phone.length - 4; i++) {
          p += "*";
        }
        return (
          phone.substring(0, 3) +
          "***" +
          phone.substring(phone.length - 2, phone.length)
        );
      }
    }
    return "";
  },
  /**
   * 更改 網頁 title
   * @param {string} name
   */
  setDocumentTitle(name) {
    if (!name && localStorage.getItem(K.document_title)) {
      document.title = localStorage.getItem(K.document_title);
    } else {
      document.title = name + "|Ricepon";
    }
  },
  /**
   * 設置 網頁 icon
   * @param {*} id
   */
  setDocumentIcon(id) {
    let logoImg = document.getElementById(id);
    let links = document.getElementsByTagName("link"); // 獲取所有 link 元素
    for (let i = 0; i < links.length; i++) {
      //遍歷 link 元素
      let link = links[i];
      let rel = link.rel; // rel 表示 link 的類型  icon 對應 shortcut icon
      rel = rel.toLowerCase(); // 部分網站 會 大寫. 統一轉成小寫
      if (rel.indexOf("icon") > -1) {
        // 當連接中存在 shortcut icon 字眼
        link.href = logoImg.src; // 修改 網站icon
        break;
      }
    }
  },
  /**
   * 獲取當前頁 的 參數
   * @param {element} t this
   */
  getQueryParams(t, s) {
    let params = t.$route.params;
    let arg = params.arg;
    if (arg) {
      return this.BASE_.dec(arg, s);
    } else {
      if (s == 1) {
        return [];
      } else {
        // 提示
        t.$dialog
          .alert({
            title: i18n.t('common.Warm_prompt'),
            message:
              i18n.t('common.Data_missing') + " " + i18n.t('common.Please_quit_and_try_again'),
            confirmButtonText: i18n.t("Confirm"),
            confirmButtonColor: this.ThemeColor,
          })
          .then(() => {
            // on close
          });
        return [];
      }
    }
  },
  getQueryParams_(params) {
    let arg = params.arg;
    if (arg) {
      return this.BASE_.dec(arg);
    }
    return [];
  },
  /**
   * 獲取 掃碼點餐 參數
   * @param {*} t
   */
  getQueryParams_qr(t) {
    try {
      let query = t.$route.query;
      let arg = query.arg;
      if (arg) {
        return JSON.parse(arg);
      } else {
        return "";
      }
    } catch (error) {
      return "";
    }
  },
  /**
   * 生成 頁面參數
   * @param {*} t
   */
  setQueryParams(t) {
    // return Base64.ba_encode(t);
    return this.BASE_.enc(t);
  },
  /**
   * 判斷 餐牌頁 是否可以返回
   * @param {*} t
   */
  getIndexBack(t) {
    try {
      let params = t.$route.params;
      let arg = params.arg;
      if (arg) {
        // return Base64.ba_decode(arg);
        let r = this.BASE_.dec(arg);
        let i = r[2];
        if (i == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  /**
   * 判斷是否是 pc
   */
  IsPC() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    // 常见移动端关键字
    const mobileRegex =
      /Android|iPhone|iPad|iPod|Huawei|Honor|MI|Redmi|OPPO|Vivo|OnePlus|Samsung|Nokia|Sony|HTC|LG|Lenovo|ZTE/i;

    // iPadOS 13+ 开始 userAgent 与 macOS 相似，需要额外判断
    const isIPadOS =
      navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

    return !(mobileRegex.test(ua) || isIPadOS);
  },
  getExplore() {
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/rv:([\d.]+)\) like gecko/))
      ? (Sys.ie = s[1])
      : (s = ua.match(/msie ([\d\.]+)/))
      ? (Sys.ie = s[1])
      : (s = ua.match(/edge\/([\d\.]+)/))
      ? (Sys.edge = s[1])
      : (s = ua.match(/firefox\/([\d\.]+)/))
      ? (Sys.firefox = s[1])
      : (s = ua.match(/(?:opera|opr).([\d\.]+)/))
      ? (Sys.opera = s[1])
      : (s = ua.match(/chrome\/([\d\.]+)/))
      ? (Sys.chrome = s[1])
      : (s = ua.match(/version\/([\d\.]+).*safari/))
      ? (Sys.safari = s[1])
      : 0;
    // 根据关系进行判断
    if (Sys.ie) return "IE: " + Sys.ie;
    if (Sys.edge) return "EDGE: " + Sys.edge;
    if (Sys.firefox) return "Firefox: " + Sys.firefox;
    if (Sys.chrome) return "Chrome"; //('Chrome:' + Sys.chrome);
    if (Sys.opera) return "Opera: " + Sys.opera;
    if (Sys.safari) return "Safari"; //('Safari: ' + Sys.safari);
    return "Other";
  },
  /**
   * 判斷是否是 蘋果瀏覽器
   * google 瀏覽器 沒有 谷歌標識  居然和 safari 瀏覽器一模一樣
   */
  isSafari() {
    let nav = navigator.userAgent.toLowerCase();
    let flag =
      /safari/.test(nav) &&
      !/chrome/.test(nav) &&
      !/qqbrowser/.test(nav) &&
      !/huawei/.test(nav);
    if (flag && util.getExplore() == "Safari") {
      return true;
    }
    return false;
  },
  /**
   * 獲取緩存中的地址
   */
  getLocaAddress() {
    let address = localStorage.getItem(K.select_address);
    let result = {
      f: false,
    };
    if (address) {
      result.t = JSON.parse(address);
      result.f = true;
    }
    return result;
  },
  /**
   * 查詢起送費
   * @param {string} addressId 地址id
   * @param {string} restaurantId 餐廳id
   */
  getQueryDeliveryFee(addressId, restaurantId, success, error) {
    // 組裝 參數
    let params = {};
    params.addressId = addressId;
    params.userId = localStorage.getItem(K.user_id);
    params.restaurantId = restaurantId;
    let menuType = localStorage.getItem(K.menu_type);
    // 判斷是否是凍鏈 -- 默認是盡快送達
    if (menuType == util.getColdType()) {
      params.companyType = 3;
    }
    queryDeliveryFee(params)
      .then((res) => {
        if (typeof success == "function") {
          success(res);
        }
      })
      .catch((err) => {
        if (typeof error == "function") {
          error(err);
        }
      });
  },
  /**
   * 根據中英文, 返回對應的值
   * @param {*} obj1 hk
   * @param {*} obj2 en
   */
  setNameByEn(obj1, obj2) {
    if (!obj2) {
      return obj1;
    }
    return i18n.check(obj1, obj2);
  },
  /**
   * 數學方法
   */
  Math: {
    /*
     * 判断obj是否为一个整数
     */
    isInteger(obj) {
      return Math.floor(obj) === obj;
    },
    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    toInteger(floatNum) {
      let ret = {
        times: 1,
        num: 0,
      };
      if (this.isInteger(floatNum)) {
        ret.num = floatNum;
        return ret;
      }
      let strfi = floatNum + "";
      let dotPos = strfi.indexOf(".");
      let len = strfi.substr(dotPos + 1).length;
      let times = Math.pow(10, len);
      let intNum = parseInt(floatNum * times + 0.5, 10);
      ret.times = times;
      ret.num = intNum;
      return ret;
    },
    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    operation(a, b, op) {
      let o1 = this.toInteger(a);
      let o2 = this.toInteger(b);
      let n1 = o1.num;
      let n2 = o2.num;
      let t1 = o1.times;
      let t2 = o2.times;
      let max = t1 > t2 ? t1 : t2;
      let result = null;
      let d = 0,
        f = 0;
      switch (op) {
        case "add":
          if (t1 === t2) {
            // 两个小数位数相同
            result = n1 + n2;
          } else if (t1 > t2) {
            // o1 小数位 大于 o2
            result = n1 + n2 * (t1 / t2);
          } else {
            // o1 小数位 小于 o2
            result = n1 * (t2 / t1) + n2;
          }
          return result / max;
        case "subtract":
          if (t1 === t2) {
            result = n1 - n2;
          } else if (t1 > t2) {
            result = n1 - n2 * (t1 / t2);
          } else {
            result = n1 * (t2 / t1) - n2;
          }
          return result / max;
        case "multiply":
          d = n1 * n2;
          f = t1 * t2;
          if ((d + "").indexOf(".") > -1 || (f + "").indexOf(".") > -1) {
            result = this.divide(d, f);
          }
          result = d / f;
          return result;
        case "divide":
          d = n1 / n2;
          f = t2 / t1;
          if ((d + "").indexOf(".") > -1 || (f + "").indexOf(".") > -1) {
            result = this.multiply(d, f);
          } else result = d * f;
          return result;
      }
    },
    // 加
    add(a = 0, b = 0) {
      return this.operation(a, b, "add");
    },
    // * 多位加
    adds(...arg) {
      let args = { ...arg };
      let all = 0;
      for (let i in args) {
        all = this.add(all, args[i]);
      }
      return all;
    },
    // 減
    subtract(a = 0, b = 0) {
      return this.operation(a, b, "subtract");
    },
    // 乘
    multiply(a = 0, b = 0) {
      return this.operation(a, b, "multiply");
    },
    // 除
    divide(a = 0, b = 1) {
      return this.operation(a, b, "divide");
    },
    /**
     * 四捨五入
     * @param {*} num 值
     * @param {*} t  小數位, 默認一位
     */
    round(num, t) {
      try {
        num = parseFloat(num);
      } catch (e) {
        num = 0;
      }
      if (!num) num = 0;
      if (!t) t = 1;
      let result =
        Math.round((num + Number.EPSILON) * Math.pow(10, t)) / Math.pow(10, t);
      let xsd = result.toString().split(".");
      let a = xsd[1];
      if (a) {
        if (a.length < t) {
          let h = t - a.length;
          return xsd[0] + "." + a + Math.pow(10, h).toString().replace("1", "");
        } else {
          return result;
        }
      } else {
        return xsd[0] + "." + Math.pow(10, t).toString().replace("1", "");
      }
    },
    /**
     * 保留小數位, 返回 1.00 格式
     */
    round_(num, t) {
      try {
        num = parseFloat(num);
      } catch (e) {
        num = 0;
      }
      if (!num) num = 0;
      if (!t) t = 1;
      let result =
        Math.round((num + Number.EPSILON) * Math.pow(10, t)) / Math.pow(10, t);
      let xsd = result.toString().split(".");
      let a = xsd[1];
      if (a) {
        if (a.length < t) {
          let h = t - a.length;
          return xsd[0] + "." + a + Math.pow(10, h).toString().replace("1", "");
        } else {
          return result;
        }
      } else {
        return xsd[0] + "." + Math.pow(10, t).toString().replace("1", "");
      }
    },
    /**
     * 賬單小數
     */
    /**
     * 金額 及 賬單小數 計算方式
     * 不是傳統的四捨五入
     * 舉個栗子,在保留一位小數的情況下:
     * 在傳統的四捨五入中  --> 0.46 ==> 0.4 //  0.66 => 0.7
     * 在自定義規則中  --> 0.4 ==> 0.0  //  0.66 ==> 0.1
     *
     * 如上文 [0.66], 保留一位小數, 但是 我有兩位, [6] [6] , 所以要先砍掉一個 [6] ==> [0.6];
     * 然後再判斷 [0] [6] , [0] 作為保留值, 先不動, [6] 作為 判斷值, 進行邏輯判斷
     * 當 進入, 四捨五入 的邏輯時, 判斷  [6 ]滿足哪個條件 ==> [6 > 0.4]
     * 因此是 [入] , 然後將 [6] 砍為 [0], 保留值 [0] 進行 ++ 操作. ==> [1.0]
     *
     */
    flexd(val, i, t) {
      console.log(val, i, t);
      if (i < 0 || i > 3 || t < 1 || t > 2) {
        return val;
      }
      if (util.isNull(i)) {
        i = 0;
      }
      if (util.isNull(t)) {
        t = 1;
      }

      // 計算 小數位

      let b = val * Math.pow(10, t); // 1.5
      let c = (b + "").split("."); // [1,5] // 1 是保留值 5 是不要的
      let d = c[0];
      let e = d / 10; // 需要拿到最好一位數字
      let f = (e + "").split(".");
      let g = f[0]; // 總值
      let h = f[1]; // 小數值, 用來判斷規則
      if (util.isNull(h)) h = 0;
      if (i == 0) {
        // [0.1-0.9 = 0]
        h = 0;
      } else if (i == 1) {
        // [0.1-0.9 = 1.0]
        if (h > 0) {
          g++; // 總值 ++
          h = 0;
        }
      } else if (i == 2) {
        //[ 0.1 - 0.4 = 0.0] && [0.5-0.9 = 1.0]
        if (h > 0 && h < 5) {
          h = 0;
        } else if (h > 4 && h < 10) {
          g++;
          h = 0;
        }
      } else if (i == 3) {
        // [0.1-0.5 = 0.5] && [0.6-0.9 = 1]
        if (h > 0 && h < 6) {
          h = 5;
        } else if (h > 4 && h < 10) {
          g++;
          h = 0;
        }
      }
      let j = parseInt(g + "" + h); // 講計算後的值重新拼接
      let k = j / Math.pow(10, t); // 按小數點重新取回值
      let l = (k + "").split("."); // 分離值, 計算後兩位是否滿足條件
      return l[0] + "." + this.addNum(l[1], t);
    },
    addNum(u, x) {
      if (util.isNull(u)) {
        // 這個判斷 是為了 當上面方法 計算為整數時, u 會 為 undefined, 所以 這裡需要給默認值
        u = "0";
      }
      let len = (u + "").length;
      let r_u = u;
      for (let i = 0; i < x - len; i++) {
        r_u += "0";
      }
      return r_u;
    },

    // 截取小数位
    splice(t = 0, n = 0) {
      t = String(t);
      if (t.includes(".")) {
        let t_ = t.split(".");
        if (n == 0) {
          return t_[0];
        } else {
          let o = t_[1];
          console.log("o", o);
          let s = o.substring(0, n);
          console.log("s", s);
          return t_[0] + "." + s;
        }
      } else return t;
    },
  },
  /**
   * 對象複製
   * @param {*} obj
   */
  cloneObject(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }
    if (Array.isArray(obj)) {
      const newArray = [];
      for (let i = 0; i < obj.length; i++) {
        newArray[i] = this.cloneObject(obj[i]);
      }
      return newArray;
    }
    const newObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = this.cloneObject(obj[key]);
      }
    }
    return newObj;
  },
  /**
   * 獲取指定時間yyyy-mm-dd dd:mm:ss 格式
   * @param {*} date  時間
   */
  getDate(date) {
    if (typeof date == "string") {
      date = date.replace(/-/g, "/");
      date = date.replace(".0", "");
    }
    let d = new Date(date);
    if (date == null || util.isNull(d.getTime() + "")) {
      d = new Date();
    }
    let m = d.getMonth() + 1;
    if (m < 10) {
      m = "0" + m;
    }
    let day = d.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    let minu = d.getMinutes();
    if (minu < 10) {
      minu = "0" + minu;
    }

    let sources = d.getSeconds();
    if (sources < 10) {
      sources = "0" + sources;
    }
    return (
      d.getFullYear() +
      "-" +
      m +
      "-" +
      day +
      " " +
      d.getHours() +
      ":" +
      minu +
      ":" +
      sources
    );
  },
  /**
   * 時間差 返回秒  time 被減數
   * @param {*} type 1 秒 2 分
   * @param {*} time 被減數
   * @param {*} time2 減數
   */
  timeDifference(type = 1, time = new Date(), time2 = new Date()) {
    if (typeof time == "string") {
      time = time.replace(/-/g, "/");
      time = time.replace(".0", "");
      time = new Date(time);
    }
    if (time2 == undefined) {
      time2 = new Date();
    } else if (typeof time2 == "string") {
      time2 = time2.replace(/-/g, "/");
      time2 = time2.replace(".0", "");
      time2 = new Date(time2);
    }
    if (type == 1) {
      return parseInt(((time2 - time) / 1000).toFixed(0));
    } else if (type == 2) {
      let m = (time2 - time) / 1000 / 60;
      return parseInt(m.toFixed(0));
    }
    return 0;
  },
  /**
   * 天數減法, 相隔幾天
   * @param {減數} t
   * @param {被減數} t_
   * @returns
   */
  getTimesDay(t = new Date(), t_ = new Date()) {
    try {
      // t.setMinutes(0);
      // t.setHours(0);
      // t.setSeconds(0);
      // t_.setMinutes(0);
      // t_.setHours(0);
      // t_.setSeconds(0);
      let x = (t - t_) / 1000 / 86400;
      return x;
    } catch (error) {
      return 0;
    }
  },
  /**
   * 天數加減
   * @param {*} date
   * @param {*} days
   */
  addDate(date, days = 0) {
    if (!util.isNull(date)) {
      date = date.replace(/-/g, "/");
      date = date.replace(".0", "");
    }
    let d = new Date(date);
    d.setDate(d.getDate() + days);
    let m = d.getMonth() + 1;
    if (m < 10) {
      m = "0" + m;
    }
    let day = d.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    return d.getFullYear() + "-" + m + "-" + day;
  },
  /**
   * 獲取 指定分鐘的時間
   * @param {number} min
   */
  addMinutes(min) {
    let d = new Date();
    d.setMinutes(d.getMinutes() + parseInt(min));
    return d;
  },
  /**
   * 輸入秒, 得到具體的天-時-分-秒
   * @param {秒} t
   * @returns
   */
  getD_H_M_S(t = 0) {
    try {
      if (t < 0) t = t * -1;
      let d = 86400, // 一天有多少秒
        h = 3600, // 一小時有多少秒
        m = 60; // 一分鐘有多少秒
      let d1 = "00",
        h1 = "00",
        m1 = "00",
        s1 = "00";
      if (t == 0) {
        return {
          f: false,
          h: h1,
          d: d1,
          m: m1,
          s: s1,
        };
      }
      if (t >= d) {
        d1 = parseInt(decimal.divide(t, d)); // 得到 天數
        if (d1 < 10) d1 = `0${d1}`;
        t = decimal.subtract(t, decimal.multiply(d1, d));
      }
      if (t >= h) {
        h1 = parseInt(decimal.divide(t, h)); // 得到小時
        if (h1 < 10) h1 = `0${h1}`;
        t = decimal.subtract(t, decimal.multiply(h1, h));
      }
      if (t >= m) {
        m1 = parseInt(decimal.divide(t, m)); // 得到分鐘
        if (m1 < 10) m1 = `0${m1}`;
        s1 = decimal.subtract(t, decimal.multiply(m1, m));
        if (s1 < 10) s1 = `0${s1}`;
      } else if (t > 0 && t < 60) {
        s1 = t;
        if (t < 10) s1 = `0${t}`;
      }
      return {
        f: true,
        h: h1,
        d: d1,
        m: m1,
        s: s1,
      };
    } catch (error) {
      console.log(error);
    }
  },
  /**
   * 獲取特定格式時間
   * @param {*} type  1 時分 2 年月日
   * @param {*} obj
   */
  fmtDate(type, obj) {
    if (typeof obj === "string") obj = obj.toString().replace(/\-/g, "/");
    let date = new Date(obj);
    let result = "";
    if (type == 1) {
      // 时分
      let h = date.getHours();
      if (h < 10) {
        h = "0" + h;
      }
      let m = date.getMinutes();
      if (m < 10) {
        m = "0" + m;
      }
      result = h + ":" + m;
    } else if (type == 2) {
      // 年月日
      let date = new Date(obj);
      let y = 1900 + date.getYear();
      let m = "0" + (date.getMonth() + 1);
      let d = "0" + date.getDate();
      result =
        y +
        "-" +
        m.substring(m.length - 2, m.length) +
        "-" +
        d.substring(d.length - 2, d.length);
    }
    return result;
  },
  /**
   * 判斷 字符串是否在arr裡
   * @param {array} obj
   * @param {string} str
   */
  isArrayContains(obj, str) {
    let arrayContains = (obj, str) => {
      let index = obj.length;
      while (index--) {
        if (obj[index] === str) {
          return true;
        }
      }
      return false;
    };
    return arrayContains(obj.split(","), str + "");
  },
  isArrayContains_(obj, str) {
    let arrayContains = (obj, str) => {
      let index = obj.length;
      while (index--) {
        if (obj[index] == str) {
          return true;
        }
      }
      return false;
    };
    return arrayContains(obj, str + "");
  },
  /**
   * 判斷是安卓還是ioc
   */
  isIosOrAndroid() {
    let sUserAgent = navigator.userAgent.toLowerCase();
    let isIphone = sUserAgent.match(/iphone/i) == "iphone";
    let isAndroid = sUserAgent.match(/android/i) == "android";
    if (isIphone) {
      return "ios";
    } else if (isAndroid) {
      return "android";
    } else {
      return "other";
    }
  },
  /**
   * 金額格式化
   * @param {int} price 金額
   * @param {int} number 數量
   * @param {int} t 小數位
   */
  toPrice(price = 0, number, t = 1, f = "$ ") {
    price = price || 0;
    t = util.ifNull(t, 1);
    if (util.isNull(number)) {
      return `${f}${util.changePrice(price + "")}`;
    } else {
      let p = decimal.multiply(price, number);
      let result = `${f}${util.changePrice(p)}`;
      return result;
    }
  },
  /**
   * 將傳入的數值 變為帶逗號的價格
   * @param {Object} p 傳入的數值
   */
  changePrice(str) {
    let result = "";
    let f = "";
    let a = str.toString();
    if (a.indexOf("-") > -1) {
      f = "-";
    } else if (a.indexOf("+") > -1) {
      f = "+";
    }
    a = a.replace(/[-+]/g, "");
    let d = a.substring(a.indexOf("."), a.length);
    a = a.substring(0, a.indexOf("."));
    let c = a.length - 4;
    for (let i = a.length - 1; i >= 0; i--) {
      if (c == i) {
        result = a[i] + "," + result;
        c -= 3;
      } else {
        result = a[i] + result;
      }
    }
    return f + result + d;
  },
  /**
   * 字符串格式化
   * @param {string} str 本體
   * @param {string} from 誰
   * @param {string} to 替換成誰
   */
  strReplace(str, from, to) {
    return str.replace(from, to);
  },
  /**
   * 獲取凍鏈類型
   * 怕會有改動, 所以單獨提出來
   */
  getColdType() {
    return 5;
  },
  /**
   * 獲取 外送 / 自取 送達時間 主體
   * @param {string} startTime  開始時間
   * @param {string} endTime 結束時間
   * @param {number} limit  時間間隔
   * @param {number} deliveryCharge  餐盒費
   * @param {number} day 持續天數
   * @param {string} w  是外送(w)還是自取(z)
   */
  getListByTimer(startTime, endTime, limit, deliveryCharge, day, w) {
    deliveryCharge = util.ifNull(deliveryCharge, 0);
    limit = parseInt(limit); // 時間間隔保證是int
    let now = new Date(); // 獲取當前時間
    let t = new Date(); // 定義開始時間
    let et = new Date(); // 定義結束時間
    let st_a = startTime.split(":"); // 分離 開始時間 時 和 分
    // 設置時間
    t.setHours(st_a[0]);
    t.setMinutes(st_a[1]);
    t.setSeconds(0);
    let e_a = endTime.split(":");
    // 設置時間
    et.setHours(e_a[0]);
    et.setMinutes(e_a[1]);
    et.setSeconds(0);
    let arr = [],
      json = {},
      nowt = false;
    // 組裝 時
    let hoursFun = (t, s) => {
      return t.getHours() < 10 ? `0${t.getHours()}${s}` : `${t.getHours()}${s}`;
    };
    // 組裝 分
    let minutesFun = (t, s) => {
      return t.getMinutes() < 10
        ? `0${t.getMinutes()}${s}`
        : `${t.getMinutes()}${s}`;
    };
    // 定義死循環, 用來組裝數據
    for (let i = 0; i < i + 1; i++) {
      json = {};
      // 當 開始時間 > 結束時間 => 結束循環
      if (t > et) {
        break;
      }
      let fl = t > now;
      if (day > 1) {
        fl = true;
      }
      if (fl) {
        json.deliveryCharge = deliveryCharge; // 設置 配送費
        json.time = `${hoursFun(t, `:`)}${minutesFun(t, `~`)}`; // 組裝前半截
        json.type = 1;
        json.show = true;
      }
      t.setMinutes(t.getMinutes() + limit); // 累加 間隔時間 這裡可能會出現 跨天, 則退出
      if (t.getDate() > now.getDate()) {
        break;
      }
      if (fl) {
        json.time += `${hoursFun(t, `:`)}${minutesFun(t, ``)}`; // 組裝後半截
        json.type = 1;
        json.show = true;
        arr.push(json); // 加入 數組
        let c = (et - t) / 1000 / 60;
        if (c > 0 && c < limit) {
          json = {};
          json.deliveryCharge = deliveryCharge;
          json.time = `${hoursFun(t, `:`)}${minutesFun(t, `~`)}`; // 組裝 前半截
          json.time += `${hoursFun(et, `:`)}${minutesFun(et, ``)}`; // 組裝 後半截
          json.type = 1;
          json.show = true;
          arr.push(json); // 接入數組
        }
      } else if (!nowt) {
        // 時間不對 設置 立即送達
        json.time =
          w == "w" ? i18n.t('common.Served_as_soon_as_possible') : i18n.t('common.immediately');
        json.type = 0;
        json.show = true;
        arr.push(json);
        nowt = true;
      }
    }
    return arr;
  },

  /**
   * * 計算 會員折扣
   * @param {*} money 金額
   * @param {*} discountData 折扣信息
   * @param {} type 1 固定碼, 2 是外送自取
   * @param itemDecimals 小數位
   * @returns
   */
  initMemberDiscount(money = 0, discountData = {}, type, itemDecimals = 0) {
    const { memberDiscount = 0 } = discountData;
    if (memberDiscount == 0) {
      return {
        show: false,
        yPrice: 0,
        sPrice: money,
        price: money,
      };
    }
    if (money == 0) {
      return {
        show: true,
        ...memberDiscount,
        yPrice: 0,
        price: 0,
      };
    }
    let yPrice = decimal.multiply(money, decimal.divide(memberDiscount, 100));
    if (type == 1) yPrice = util.Math.splice(yPrice, itemDecimals);
    else if (type == 2) yPrice = util.Math.round(yPrice);
    return {
      show: true,
      ...memberDiscount,
      yPrice: yPrice,
      sPrice: decimal.subtract(money, yPrice),
      price: money,
    };
  },

  /**
   * 自動折扣 初始化
   * @param {*} discountData  自動折扣數據
   * @param {*} gCouponAmount 優惠券計算金額
   * @param {*} money  購物車總金額
   * @param {*} distributionFee 運費
   * @param {*} totalLunchbox 餐盒費
   * @param {*} ist 'wm' 或者 'zq'
   * @param {*} isActive 是否開啟自動折扣
   * @param {} couponExclusive 優惠券是否開啟獨佔
   *
   * @return {object} result 返回的數據 , 包含 show 是否顯示折扣,  id 折扣id, yPrice 折扣優惠金額, gCouponAmount 折扣剩餘金額 (優惠券計算用), name 自動折扣名稱, otherPrice 其他應該需要在最後計算到總金額中的金額 ,isDisFee 是否免除運費 , disFee 運費
   */
  initDiscount(
    discountData,
    gCouponAmount,
    money,
    distributionFee,
    totalLunchbox,
    ist,
    isActive,
    couponExclusive = 0
  ) {
    console.log(isActive);
    // 初始化 起送費
    distributionFee = util.ifNull(distributionFee, 0);
    // 初始化 餐盒費
    totalLunchbox = util.ifNull(totalLunchbox, 0);
    // 定義返回內容
    let result = {};
    result.hasOpen = false;
    result.isDisFee = false;
    // 當 折扣數據為空 或 未開啟折扣時
    if (!discountData || !isActive) {
      result.show = false;
      result.yPrice = 0;
      result.id = "";
      result.otherPrice = util.Math.round(
        decimal.add(distributionFee, totalLunchbox)
      );
      result.gCouponAmount = util.Math.round(money);
      return result;
    }

    // * 如果開啟了 優惠券 獨佔, 則不計算自動折扣
    if (couponExclusive == 1) {
      result.hasOpen = true;
      result.show = true;
      result.yPrice = 0;
      result.id = "";
      result.otherPrice = util.Math.round(
        decimal.add(distributionFee, totalLunchbox)
      );
      result.gCouponAmount = util.Math.round(money);
      return result;
    }
    // 使用場景 落單類型 0：餐檯模式，1：外送模式，2：外送模式，3：自取模式 4 凍鏈
    let placeOrderType = discountData.placeOrderType || "";
    if (ist == "wm") {
      // 判斷凍鏈
      let menuType = localStorage.getItem(K.menu_type);
      if (menuType == util.getColdType()) {
        if (placeOrderType.indexOf("4") == -1) {
          result.yPrice = 0;
          result.show = false;
          result.id = "";
          result.otherPrice = util.Math.round(
            decimal.add(distributionFee, totalLunchbox)
          );
          result.gCouponAmount = util.Math.round(money); // 優惠券 計算金額, 就是 食品金額
          return result;
        }
      } else {
        if (placeOrderType.indexOf("2") == -1) {
          result.yPrice = 0;
          result.show = false;
          result.id = "";
          result.otherPrice = util.Math.round(
            decimal.add(distributionFee, totalLunchbox)
          );
          result.gCouponAmount = util.Math.round(money); // 優惠券 計算金額, 就是 食品金額
          return result;
        }
      }
    } else if (ist == "zq") {
      if (placeOrderType.indexOf("3") == -1) {
        result.show = false;
        result.yPrice = 0;
        result.id = "";
        result.otherPrice = util.Math.round(
          decimal.add(distributionFee, totalLunchbox)
        );
        result.gCouponAmount = util.Math.round(money); // 優惠券 計算金額, 就是 食品金額
        return result;
      }
    } else {
      result.yPrice = 0;
      result.show = false;
      result.id = "";
      result.otherPrice = util.Math.round(
        decimal.add(distributionFee, totalLunchbox)
      );
      result.gCouponAmount = util.Math.round(money); // 優惠券 計算金額, 就是 食品金額
      return result;
    }

    // 先判斷 優惠類型.
    let type = discountData.type; // 0 金額, 1 折扣
    let amountTypeMin = discountData.amountTypeMin; // 0 合計 1 總金額
    let restrictionAmount = discountData.restrictionAmount; // 最低消費金額 0 元表示不受限制
    let isDeliveryFee = discountData.isDeliveryFee; //免運費 0 否 1 是

    // 這裡算出 優惠金額
    let allMoney = 0; // 可折扣 總金額
    let yPrice = 0; // 優惠的金額
    let otherPrice = 0; // 其他需要最後算入總合計的金額
    if (amountTypeMin == 0) {
      allMoney = parseFloat(util.Math.round(money)); // 總計
      otherPrice = decimal.add(distributionFee, totalLunchbox); // 餐盒費和運費
    } else {
      let zAmount = decimal.add(
        decimal.add(distributionFee, parseFloat(util.Math.round(money))),
        totalLunchbox
      ); // 拿到總金額
      allMoney = parseFloat(zAmount); // 總金額
    }
    // 判斷 最低消費金額
    if (allMoney >= restrictionAmount) {
      if (isDeliveryFee == 1 && amountTypeMin == 1) {
        // 免運費 && 當前是總金額
        allMoney = decimal.subtract(allMoney, distributionFee); // 計算時, 把運費排除
        if (amountTypeMin == 0) {
          otherPrice = decimal.subtract(otherPrice, distributionFee);
        }
      }
      // 判斷 折扣類型
      if (type == 0) {
        // 金額
        let amount = discountData.amount; // 可優惠金額
        let am = decimal.subtract(allMoney, amount); // 優惠後的金額
        if (am < 0) {
          am = 0;
          yPrice = allMoney; // 優惠金額
        } else {
          yPrice = amount; // 優惠金額
        }
        gCouponAmount = am; // 設置 優惠券 判定金額
      } else {
        // 折扣
        let discountValue = discountData.discountValue; // 拿到優惠比例餓
        let y = decimal.divide(decimal.subtract(100, discountValue), 100); // 拿到折扣
        let am = util.Math.round(decimal.multiply(allMoney, y)); // 拿到優惠後金額
        yPrice = util.Math.round(decimal.subtract(allMoney, am)); // 拿到 優惠金額
        gCouponAmount = am; // 設置 優惠券 判定金額
      }
    } else {
      result.yPrice = 0;
      result.id = "";
      result.show = false;
      result.otherPrice = util.Math.round(
        decimal.add(distributionFee, totalLunchbox)
      );
      result.gCouponAmount = util.Math.round(money); // 優惠券 計算金額, 就是 食品金額
      return result;
    }
    if (yPrice < 0) yPrice = 0;
    if (isDeliveryFee == 1) {
      // 免運費
      yPrice = decimal.add(yPrice, distributionFee); // 最終結果需要把運費加上
      otherPrice = decimal.subtract(otherPrice, distributionFee);
      result.isDisFee = true;
      result.disFee = distributionFee;
    }
    result.yPrice = util.Math.round(yPrice);
    result.gCouponAmount = util.Math.round(gCouponAmount);
    result.id = discountData.id;
    result.show = true;
    result.otherPrice = otherPrice < 0 ? 0 : util.Math.round(otherPrice);
    result.name = util.setNameByEn(discountData.remark, discountData.remark2);
    return result;
  },
  /**
   * 計算優惠券優惠
   * @param {object} couponData  優惠券數據
   * @param {number} money  金額
   */
  initCounpon(couponData = {}, money, itemDecimals) {
    let result = {};
    result.show = false; // * 沒有優惠券
    // * exclusive：獨佔折扣 0：否，1：是
    result.exclusive = couponData.exclusive || 0;
    let money_ = 0;
    if (!couponData) {
      return result;
    }
    if (!util.isNull(couponData.id)) {
      // 計算優惠後金額
      let couponMoney = couponData.amount, //優惠金額
        discount = couponData.discount, // 折扣
        couponType = couponData.couponType, // 優惠類型
        spend = couponData.spend, // 消費滿
        billMinAmount = couponData.billMinAmount, // 優惠上線
        accumulate = couponData.accumulate || 0; // 是否開啟累加
      if (spend < 0) spend = 0;
      // 是否滿足使用優惠券條件,
      if (spend > money) {
        // 頁面上顯示  滿xx可用,當前為xx
        result.spend = spend;
        result.money = money;
        return result;
      }
      // 優惠金額
      if (couponType == 2) {
        // 優惠後金額
        money_ = decimal.subtract(money, couponMoney);
        // 判斷是否開啟累加, 並重新開始計算
        if (accumulate != 0 && spend != 0) {
          // 拿到優惠總次數
          let dm = parseInt(decimal.divide(money, spend));
          // 拿到 總優惠金額
          let ym = decimal.multiply(dm, couponMoney);
          // 存在 優惠上線
          if (billMinAmount > 0) {
            // 當 總優惠金額, 超出了 優惠上線, 則 優惠金額 = 優惠上線
            if (ym > billMinAmount) {
              ym = billMinAmount;
            }
          }
          // 優惠後金額
          money_ = decimal.subtract(money, ym);
          couponMoney = ym;
        }
      } else {
        //折扣
        // 計算優惠金額,
        let ym = decimal.multiply(money, decimal.divide(discount, 100));
        // 存在 優惠上線
        if (billMinAmount > 0) {
          // 當 總優惠金額, 超出了 優惠上線, 則 優惠金額 = 優惠上線
          if (ym > billMinAmount) {
            ym = billMinAmount;
          }
        }
        // 優惠後金額
        money_ = decimal.subtract(money, ym);
        couponMoney = ym;
      }
      if (money_ < 0) {
        couponMoney = money;
        money_ = 0;
      }
      result.show = true;
      result.id = couponData.id; // 優惠券id
      result.couponId = couponData.couponId; // 使用優惠券的id
      // 判斷, 是否傳入了 itemDecimals , 固定碼送單時, 需要按規則 進行小數位截取
      result.yPrice =
        typeof itemDecimals === "number"
          ? util.Math.splice(couponMoney, itemDecimals)
          : util.Math.round(couponMoney); // 優惠金額
      result.name = util.setNameByEn(
        couponData.couponTypeName,
        couponData.couponTypeName1
      );
      // 校驗
      let p_ = util.Math.round(money_);
      if (decimal.subtract(money, result.yPrice) != p_) {
        p_ = decimal.subtract(money, result.yPrice);
      }
      result.price = p_; //優惠優金額
      return result;
    }
    return result;
  },
  /**
   * 判斷字符串中是否存在 表情
   * @param {string} substring
   */
  isEmojiCharacterIndex(substring) {
    if (substring) {
      let flag = false;
      let index = -1;
      for (let i = 0; i < substring.length; i++) {
        let hs = substring.charCodeAt(i);
        // console.log(hs, i)
        if (0xd800 <= hs && hs <= 0xdbff) {
          if (substring.length > 1) {
            let ls = substring.charCodeAt(i + 1);
            let uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
            if (0x1d000 <= uc && uc <= 0x1f77f) {
              flag = true;
              index = i;
              break;
            }
          }
        } else if (substring.length > 1) {
          let ls = substring.charCodeAt(i + 1);
          if (ls == 0x20e3) {
            flag = true;
            index = i;
            break;
          }
        } else {
          if (0x2100 <= hs && hs <= 0x27ff) {
            flag = true;
            index = i;
            break;
          } else if (0x2b05 <= hs && hs <= 0x2b07) {
            flag = true;
            index = i;
            break;
          } else if (0x2934 <= hs && hs <= 0x2935) {
            flag = true;
            index = i;
            break;
          } else if (0x3297 <= hs && hs <= 0x3299) {
            flag = true;
            index = i;
            break;
          } else if (
            hs == 0xa9 ||
            hs == 0xae ||
            hs == 0x303d ||
            hs == 0x3030 ||
            hs == 0x2b55 ||
            hs == 0x2b1c ||
            hs == 0x2b1b ||
            hs == 0x2b50
          ) {
            flag = true;
            index = i;
            break;
          }
        }
      }
      return index;
    }
  },
  /**
   * 表情校驗 字符截斷
   * @param {*} index
   * @param {*} str
   */
  subToIndex(index, str) {
    let res = str.substring(0, index);
    res += str.substring(index + 2, str.length);
    return res;
  },
  /**
   * 外部調用
   * @param {str} str
   */
  isEmojiCharacter(str) {
    let str_ = str;
    let flag = false;
    let msg = {};
    let regStr =
      /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
    if (regStr.test(str_)) {
      str_ = str_.replace(regStr, "");
      msg.data = str_;
      msg.res = true;
      return msg;
    }
    // 利用死循环 将每一个表情剔除
    for (let i = 0; i < 1 + i; i++) {
      let index = util.isEmojiCharacterIndex(str_);
      if (index > -1) {
        flag = true;
        str_ = util.subToIndex(index, str_);
      } else {
        break;
      }
    }
    msg.data = str_;
    msg.res = flag;
    return msg;
  },
  /**
   * 查詢訂單記錄
   * @param {number} objInfo  頁碼 或者的固定碼對象
   */
  getOrderList(objInfo) {
    return new Promise((a, b) => {
      let params = {};
      if (typeof objInfo == "object") {
        params.pageIndex = objInfo.pageIndex;
        params.orderTypeList = objInfo.orderTypeList || 9; // 默認 1 店鋪訂單 2 外送 3  8 7 自取 9 固定碼
      } else {
        params.pageIndex = objInfo;
      }
      params.pageSize = 20;
      let re_type = localStorage.getItem(K.re_type);
      if (re_type == 6) {
        params.memberId = localStorage.getItem(K.user_id) || 0;
      } else {
        params.memberId = objInfo.memberId || localStorage.getItem(K.user_id);
      }
      params.brandId = localStorage.getItem(K.brand_id);
      params.restaurantId = localStorage.getItem(K.restaurant_id);
      if (objInfo.session) {
        params.session = objInfo.session;
      }
      getMemberOrderList(params)
        .then((res) => {
          a(res);
        })
        .catch((err) => {
          b(err);
        });
    });
  },
  /**
   * 加解密
   * 加密後會出現 =, 將= 替換成 Rp8 意思是 ricepon82002022 的縮寫.
   */
  BASE_: {
    // 解密
    dec(str, t) {
      try {
        let tt = str.replace(/Rp8/g, "=");
        tt = tt.replace(/RP8/g, "=");
        let r = window.atob(tt);
        let arg = [];
        arg = r.split("_");
        return arg; //把base64解码
      } catch (error) {
        if (t != 1) location.href = "/shop/error";
        else return [];
      }
    },
    // 加密
    enc(obj) {
      let k = obj;
      if (typeof obj == "object") {
        k = obj.join("_");
      }
      let enc_ = window.btoa(k);
      return enc_.replace(/=/g, "Rp8");
    },
  },
  getSubmitKey(qrcode) {
    let ran = Math.random().toString(36).substr(2); //生成 11 位數隨機字母+數字碼
    let timestamp2 = new Date().valueOf(); // 獲取當前時間的時間戳
    return ran + qrcode.substring(8, 24) + timestamp2;
  },
  /**
   * 設置 標題  關鍵字 內容
   */
  setKeyword() {
    // 替換掉 標籤符號
    let repl = (str) => {
      if (util.isNull(str)) {
        return "";
      }
      return str
        .replace(/<.*\/>/g, "")
        .replace(/<\/.*>/g, "")
        .replace(/<.*>/g, "");
    };
    let brandId = localStorage.getItem(K.brand_id);
    let restaurantId = localStorage.getItem(K.restaurant_id);
    if (brandId && restaurantId && brandId != "undefined") {
      // * 判断是否是微信环境
      const isWeChat =
        /MicroMessenger/i.test(navigator.userAgent) || // 移动端微信
        /WindowsWechat/i.test(navigator.userAgent); // PC端微信
      if (isWeChat) {
        document.title = "RICEPON";
        return;
      }

      getSeo({
        brandId: brandId,
        restaurantId: restaurantId,
      })
        .then((res) => {
          if (res.success) {
            let data = res.data;
            let title = `${data.name}|Ricepon|${data.serviceName || ""}`;
            document.title = title;
            let description = `${data.name || ""},${data.address || ""},${
              data.description || ""
            },隨時隨地為你搜羅最新飲食資訊，幫你集齊最多飲食優惠！用一個APP就可以幫你搞掂從點餐落單到成為會員儲積分，仲可以隨時開展屬於餐廳嘅專屬營銷活動，直接達成從經營到營銷到營利！`;
            let keyword = `${data.name},ricpeon,飯糰,掃碼點餐,點餐,外送,自取,順豐冷鏈,pos,手機點餐,qrcode,收銀機,低成本,雲端點餐,薑,一體式,飲食,方便,經濟效益,高智能,落單,ricepon,飯糰,會員系統,雲端,輕鬆,快捷,智能手機,android,ios,客人落單,保留客人,客人需求,消費者,電腦軟件,餐飲系統,薑,高效能,點餐,服務,電腦公司,電腦硬件,出單機,熱感紙,收銀機,飯糰,優惠券,著數,折扣,積分,獎賞,餐廳,搵食,餐廳推介,朋友聚會`;
            document.querySelector("meta[name=keywords]").content =
              repl(keyword);
            document.querySelector("meta[name=description]").content =
              repl(description);
          }
        })
        .catch((err) => {});
    }
  },
  /**
   * 手機橫屏處理
   */
  setPhoneRotate() {
    if (document.getElementById("preventTran")) {
      document.getElementById("preventTran").remove();
    }
    let imgData =
      "data:image/png;base64,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";
    let pd = document.createElement("div");
    pd.setAttribute("id", "preventTran");
    pd.style.position = "fixed";
    pd.style.left = "0";
    pd.style.top = "0";
    pd.style.width = "100%";
    pd.style.height = "100%";
    pd.style.overflow = "hidden";
    pd.style.backgroundColor = "#2e2e2e";
    pd.style.textAlign = "center";
    pd.style.zIndex = "99999";
    document.getElementsByTagName("body")[0].appendChild(pd);
    var img = document.createElement("img");
    img.src = imgData;
    pd.appendChild(img);
    img.style.margin = "60px auto 30px";
    var br = document.createElement("br");
    var p = document.createElement("p");
    p.style.width = "100%";
    p.style.height = "auto";
    p.style.fontSize = "22px";
    p.style.color = "#626262";
    p.style.lineHeight = "34px";
    p.style.textAlign = "center";
    p.innerHTML = "為了您的良好體驗";
    p.appendChild(br);
    p.innerHTML += "請將手機/平板豎屏操作";
    pd.appendChild(p);
  },
  /**
   * 加入品牌
   * @param {*} memberId
   * @param {*} phone
   * @param {*} brandId
   * @param {*} webSource // 叫號 20 套票 21
   */
  joinBrand(memberId, phone, obj, fun) {
    let brandId = "",
      appType = 7,
      webSource = "";
    if (typeof obj != "object") brandId = obj;
    else {
      brandId = obj.brandId;
      appType = obj.appType || 7;
      webSource = obj.webSource || "";
    }
    joinBrand({
      memberId: memberId,
      phone: phone,
      brandId: brandId,
      appType: appType,
      webSource: webSource,
    })
      .then((res) => {
        console.log(res);
        if (typeof fun == "function") {
          fun(res);
        }
      })
      .catch((err) => {});
  },
  // 獲取協議
  // 1:app协议;2:品牌协议;3:注册协议;4:自取協議;5:食品協議;6:外送協議; 7活動協議 8 分享內容 9 隱私協議  10 商戶服務協議 11 商戶隱私權限政策 12 RICEPON會員
  getResource: {
    request(params, success, error) {
      getResourceInfo(params)
        .then((res) => {
          if (typeof success === "function") {
            success(res);
          }
        })
        .catch((err) => {
          if (typeof error === "function") {
            error(err);
          }
        });
    },
    // 品牌協議
    brand(brandId, success, error) {
      this.request({ brandId: brandId, type: 2 }, success, error);
    },
    // 外送協議 Delivery
    delivery(brandId, success, error) {
      this.request({ brandId: brandId, type: 6 }, success, error);
    },
    // 食品協議
    foods(brandId, ids, success, error) {
      this.request({ brandId: brandId, ids: ids, type: 5 }, success, error);
    },
    // 活動
    activities(brandId, success, error) {
      this.request({ brandId: brandId, type: 7 }, success, error);
    },
    // 自取協議
    invite(brandId, success, error) {
      this.request({ brandId: brandId, type: 4 }, success, error);
    },
    // 系统协议
    ricepon(success, error) {
      this.request({ type: 12 }, success, error);
    },
    // 註銷協議
    logout(success, error) {
      this.request({ type: 14 }, success, error);
    },
    // 註銷協議
    biefuLogout(success, error) {
      this.request({ type: 16 }, success, error);
    },
    // 別忘了
    biewanglLogout(success, error) {
      this.request({ type: 21 }, success, error);
    },
    // sunRise
    sunriseLogout(success, error) {
      this.request({ type: 22 }, success, error);
    },
  },
  getResourcePromise: {
    request(params) {
      return getResourceInfo(params);
    },
    ricepon() {
      return this.request({ type: 12 });
    },
    brand(brandId) {
      return this.request({ brandId: brandId, type: 2 });
    },
  },
  /**
   * 獲取 樣式
   * @param {元素節點/類名} ele
   * @param {具體屬性} style
   * @returns
   */
  getStyle(ele, style) {
    try {
      if (typeof ele == "object") {
        let p = ele.style[style];
        if (!p) p = getComputedStyle(ele)[style];
        return p;
      } else {
        let dom = document.querySelector(ele);
        let p = dom.style[style];
        if (!p) p = getComputedStyle(dom)[style];
        return p;
      }
    } catch (error) {
      console.log(error);
      return "";
    }
  },
  // oss 圖片裁剪 具體參考 https://help.aliyun.com/document_detail/44688.html
  getOssObjectFit(url = "", w = 150, h = 150) {
    if (!url) url = "";
    url = this.getImageUrl(url);
    if (url.indexOf("ricepon.oss") > -1)
      // * 將 ? 後面的移除
      url = url.split("?")[0];
    return `${url}?x-oss-process=image/resize,limit_0,m_fill,w_${parseInt(
      w
    )},h_${parseInt(h)}`;
    return url;
  },
  /**
   * 拼湊 完整的 圖片路徑
   * @param {*} url
   * @returns
   */
  getImageUrl(url = "") {
    // 判斷圖片是否存在 且  沒有包含 http
    let pattern = /\/[\w]+\.[a-zA-Z]{3,4}$/i;
    if (url && !url.includes("http") && pattern.test(url)) {
      // 獲取環境配置
      let envHost = localStorage.getItem("envHost") || "oss";
      if (envHost == "oss") {
        // 判斷是 本地 或 hktest
        if (
          location.origin.includes("http://") ||
          location.host.includes("hktest.ricepon.com")
        )
          url = `https://hk-ricepon.oss-cn-hongkong.aliyuncs.com/${url}`;
        else url = `https://ricepon.oss-cn-hongkong.aliyuncs.com/${url}`;
      }
      // aws
      else {
      }
    }
    return url;
  },

  getImageConfigFun() {
    getImageConfig().then((res) => {
      console.log(res);
    });
  },
  /**
   * 獲取 rgb 格式
   * @param {*} rgba
   * @returns rgba rgb
   */
  getRgba(rgba) {
    if (rgba)
      rgba = rgba.replace("rgba(", "").replace("rgb(", "").replace(")", "");
    // 判斷 rgb 是否合理 不合理 設置默認值
    let rgb = rgba;
    let f = 1;
    try {
      let rgbArr = rgba.split(",");
      if (rgbArr.length == 4) {
        f = rgbArr.splice(3, 1);
        rgb = rgbArr.join(",");
      } else if (rgbArr.length != 3) {
        rgb = "";
      }
    } catch (error) {
      rgb = "";
    }
    return {
      rgba: `rgba(${rgb},${f})`,
      rgb: `rgb(${rgb})`,
      rgba_t: `${rgb},${f}`,
      rgb_t: rgb,
    };
  },
  // 用戶方法
  userInfoFun: {
    // 設置用戶信息
    set(memberInfo, brandId, key) {
      if (key == "id" || typeof key == "undefined")
        localStorage.setItem(K.user_id, memberInfo.id || memberInfo.memberId);
      if (key == "phone" || typeof key == "undefined")
        localStorage.setItem(K.user_phone, memberInfo.phone || "");
      if (key == "sex" || typeof key == "undefined")
        localStorage.setItem(K.user_sex, memberInfo.sex);
      if (key == "memberName" || typeof key == "undefined")
        localStorage.setItem(K.user_name, memberInfo.memberName || "");
      if (key == "headImg" || typeof key == "undefined")
        localStorage.setItem(K.headImg, memberInfo.headImg || "");
      if (key == "birthday" || typeof key == "undefined")
        localStorage.setItem(K.user_birthday, memberInfo.birthday || "");
      if (key == "email" || typeof key == "undefined")
        localStorage.setItem(K.user_email, memberInfo.email || "");
      if (brandId != undefined && brandId != null && brandId != "")
        util.joinBrand(memberInfo.id, memberInfo.phone, brandId);
      store.commit("setHasLogin", true);
    },
    // 獲取用戶信息
    get() {
      let id = localStorage.getItem(K.user_id) || "";
      let phone = localStorage.getItem(K.user_phone) || "";
      let sex = localStorage.getItem(K.user_sex) || "";
      let name = localStorage.getItem(K.user_name) || "";
      let headImg = localStorage.getItem(K.headImg) || "";
      let birthday = localStorage.getItem(K.user_birthday) || "";
      let email = localStorage.getItem(K.user_email) || "";
      let openid = localStorage.getItem("user_openid") || "";
      return { id, phone, sex, name, headImg, birthday, email, openid };
    },
    // 清除數據
    clear(back) {
      localStorage.removeItem(K.user_id);
      localStorage.removeItem(K.user_phone);
      localStorage.removeItem(K.select_address);
      localStorage.removeItem(K.user_name);
      localStorage.removeItem(K.user_sex);
      localStorage.removeItem(K.headImg);
      localStorage.removeItem(K.user_birthday);
      localStorage.removeItem(K.user_email);

      store.commit("setHasLogin", false);
      if (typeof back == "function") back();
    },
    // 判斷是否登錄
    isLogin() {
      let userInfo = this.get();
      const isWeChat =
        /MicroMessenger/i.test(navigator.userAgent) || // 移动端微信
        /WindowsWechat/i.test(navigator.userAgent); // PC端微信
      if (isWeChat) {
        let isLogin =
          store.getters.getHasLogin || (!!userInfo.id && !!userInfo.openid);
        if (isLogin) store.commit("setHasLogin", true);
        return isLogin;
      } else {
        let isLogin =
          store.getters.getHasLogin || (!!userInfo.id && !!userInfo.phone);
        if (isLogin) store.commit("setHasLogin", true);
        return isLogin;
      }
    },
  },
  /**
   * 食品存入後天
   */
  foodRedis: {
    /**
     * 添加
     * @param {*} key
     * @param {*} foods
     * @returns
     */
    add(key, foods) {
      if (typeof foods == "object") foods = JSON.stringify(foods);
      return addFoodRedis({
        key: key,
        value: foods,
      });
    },
    /**
     * 獲取
     * @param {*} key
     */
    get(key) {
      return getFoodRedis({
        key,
      });
    },
    /**
     * 清除
     * @param {*} key
     * @returns
     */
    clear(key) {
      return clearFoodRedis({ keys: key });
    },
  },
  /**
   * 16 轉 rgb
   * @param {*} color
   * @returns
   */
  olorRgb(color) {
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColor = color.toLowerCase();
    if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
        var sColorNew = "#";
        for (var i = 1; i < 4; i += 1) {
          sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = sColorNew;
      }
      //处理六位的颜色值
      var sColorChange = [];
      for (var i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return sColorChange.join(",");
    } else {
      let rgbs = util.getRgba(sColor);
      return rgbs.rgb_t;
    }
  },
  /**
   * rgb 轉 16
   * @param {*} color
   * @returns
   */
  _RgbTo16(color) {
    let values = color
      .replace(/rgba?\(/, "")
      .replace(/\)/, "")
      .replace(/[\s+]/g, "")
      .split(",");
    let a = parseFloat(values[3] || 1),
      r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
      g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
      b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
    return (
      "#" +
      ("0" + r.toString(16)).slice(-2) +
      ("0" + g.toString(16)).slice(-2) +
      ("0" + b.toString(16)).slice(-2)
    );
  },
  /**
   *  設置動態顏色
   * @param {*} name
   * @param {*} color
   */
  // setRootColor(name, color) {
  //   let root = document.querySelector(":root");
  //   root.setAttribute("style", `${name}: ${color}`);
  // },
  setRootFontSize(name, size) {
    let root = document.documentElement;
    root.style.setProperty(`${name}`, `${size}`);
  },
  setRootColor(name, color) {
    let root = document.documentElement;
    root.style.setProperty(`${name}`, `${color}`);
  },
  /**
   * 判斷估清
   * @param {*} menuType
   * @returns
   */
  getValuation(menuType) {
    console.log("menuType", menuType);
    let arr = [1, 2, 4, 7, 10, 21, 22];
    if (menuType) menuType = parseInt(menuType);
    if (arr.indexOf(menuType) > -1) {
      return true;
    }
    return false;
  },
  /**
   * 排序
   * @param {*} arr 數組
   * @param {*} type  第一級 - 第四級
   */
  sort(arr, type) {
    // clone 原數據, 避免修改了外部數據
    let arr_ = util.cloneObject(arr);
    // 開始排序
    arr_.sort((a, b) => {
      // 取 組類型 3 食品 4 細項
      let at = a.foodType || 0,
        bt = b.foodType || 0;
      // 當 組類型一致, 判斷 排序
      if (at == bt) {
        let akey = 0,
          bkey = 0;
        // 各級的排序, 以及 套餐/細項排序 不是一個字段
        if (type == 1 || type == 3) {
          akey = a.fcSeqNo || a.fmSeqNo || 0;
          bkey = b.fcSeqNo || b.fmSeqNo || 0;
        } else if (type == 2 || type == 4) {
          akey = a.mSeqNo || a.ciSeqNo || 0;
          bkey = b.mSeqNo || b.ciSeqNo || 0;
        }
        if (akey != bkey) {
          return akey - bkey;
        } else {
          // 套餐id  和 細項id  不是一個字段, 分開取
          let aid = a.fmId || a.fcId || a.id;
          let bid = b.fmId || b.fcId || b.id;
          return aid - bid;
        }
      } else {
        // 4(細項) 的 排在前面
        return at == 4 ? -1 : 1;
      }
    });
    return arr_;
  },
  // 時間方法
  time: {
    types: {
      1: "YYYY-MM-DD HH:mm:ss", // 年月日 時分秒
      2: "YYYY-MM-DD", // 年月日
      3: "MM-DD", // 月日
      4: "HH:mm:ss", // 時分秒
      5: "HH:mm", // 時分
      6: "YYYYMMDD", // 年月日
      7: "MM-DD HH:mm",
      8: "YYYY-MM-DD HH:mm",
      9: "YYYY/MM/DD",
    },
    /**
     * 格式化
     * @param {number} type
     * @param {string||number||Date} d
     * @returns
     */
    format(type = 1, d) {
      if (!d) d = new Date();
      else if (typeof d == "string") {
        d = d.replace(/-/g, "/");
        d = d.replace(".0", "");
      }
      let date = d;
      if (typeof d === "string" || typeof d === "number") date = new Date(d);
      return moment(date).utcOffset(8).format(this.types[type]);
    },
    // ? 判断 时间是否已过期
    // ? 使用方式：isExpired('2026-03-26 10:00:00') => true/false
    // ? 参数：time - 要判断的时间（支持 Date、字符串、时间戳），format - 时间格式（可选）
    // ? 返回：Boolean，true 表示已过期，false 表示未过期
    isExpired(time, format) {
      if (!time) return true;
      let targetDate;
      if (format) {
        targetDate = moment(time, format);
      } else {
        targetDate = moment(time);
      }
      return targetDate.isBefore(moment());
    },
  },
  window: {
    /**
     * ? 處理經緯度
     * @param {number} arg1 經度或緯度
     * @param {number} arg2 緯度或經度
     * @returns {object} {lat, lng} 正確的經緯度對象
     */
    getLatLng(arg1, arg2) {
      let lat, lng;
      // * 判斷 arg1 和 arg2 的範圍，確定哪個是緯度，哪個是經度
      // * 緯度範圍：-90 到 90
      // * 經度範圍：-180 到 180
      const num1 = Number(arg1) || 0;
      const num2 = Number(arg2) || 0;

      if (Math.abs(num1) <= 90 && Math.abs(num2) <= 180) {
        // * num1 是緯度，num2 是經度
        lat = num1;
        lng = num2;
      } else if (Math.abs(num1) <= 180 && Math.abs(num2) <= 90) {
        // * num1 是經度，num2 是緯度
        lat = num2;
        lng = num1;
      } else {
        // * 都不符合範圍，返回默認值
        lat = 0;
        lng = 0;
      }

      return { lat, lng };
    },
  },
  // 獲取 瀏覽器信息
  getBrowserType() {
    var ua = navigator.userAgent.toLowerCase();
    var msg = {};
    msg.type = "other";
    if (ua.indexOf(" qq") > -1) {
      //qq内置浏览器 （‘ qq’） qq浏览器 （‘qq’）
      msg.type = "QQ";
    }
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //微信浏览器
      msg.type = "Wx";
    }
    if (ua.indexOf("alipayclient") > -1) {
      //判断是否是支付宝浏览器打开
      msg.type = "zfb";
      return msg;
    }
    if (ua.match(/Alipay/i) == "alipay") {
      msg.type = "Ali";
    }
    return msg;
  },
  image: {
    /**
     * 上傳文件
     * @param { file } obj
     * @param { function } back
     */
    uploadFile(file, back = () => {}) {
      getSignature().then((res) => {
        if (res.success) {
          let policyData = res.data;
          let ossUrl = policyData.host;
          let name = file.name || "";
          if (name) {
            name = file.name.split(".")[1];
          } else {
            name = ".png";
          }
          let accessUrl = policyData.dir + "/" + Date.now() + name; //上傳路徑
          let sendData = new FormData();
          sendData.append("OSSAccessKeyId", policyData["accessKeyId"]);
          sendData.append("policy", policyData["encodedPolicy"]);
          sendData.append("Signature", policyData["postSignature"]);
          sendData.append("keys", policyData["dir"]);
          sendData.append("key", accessUrl); //上传的文件路径
          sendData.append("success_action_status", 200); // 指定返回的状态码
          sendData.append("type", "image/*");
          sendData.append("file", file);
          sendData.append("configType", "ossFile");
          // 開始上傳
          ossUploadImg(ossUrl, sendData)
            .then((res) => {
              // 成功后没有回调， 只要觸發了 then , 就默認為成功
              let file = ossUrl + "/" + accessUrl; //获得到的url需要将其存数据库中
              back({
                success: true,
                data: file,
              });
            })
            .catch((e) => {
              console.log(e);
              back({
                success: false,
              });
            });
        }
      });
    },
    // base64 轉 file
    dataURLtoFile(dataURI, type) {
      let binary = window.atob(dataURI.split(",")[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    downloadRemoteImg(url, filename) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, filename);
      });
    },
    /**
     * 获取 blob
     * @param  {String} url 目标文件地址
     * @return {cb}
     */
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },
    /**
     * 保存
     * @param  {Blob} blob
     * @param  {String} filename 想要保存的文件名称
     */
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    /**
     * 處理 後台的 富文本 圖片
     * @param {*} describeText
     * @returns
     */
    initTextArea(describeText) {
      if (describeText) {
        let div = document.createElement("div");
        div.innerHTML = describeText;
        // 富文本 圖片解析
        if (div.nodeType == 1) {
          let imgs = div.querySelectorAll("img");
          for (let i in imgs) {
            if (imgs[i].nodeType === 1) {
              imgs[i].style.maxWidth = "100%";
              imgs[i].style.height = "auto";
              let src = imgs[i].src;
              console.log(src);
              // 如果是相對路徑, 取值時, 會自動拼上當前域名和路徑
              console.log(
                (!src.includes("http") && src.includes("images/")) ||
                  src.includes("/activities/") ||
                  src.includes("192.") ||
                  src.includes("ricepon.com")
              );
              if (
                (!src.includes("http") && src.includes("images/")) ||
                src.includes("/activities/") ||
                src.includes("192.") ||
                src.includes("ricepon.com") ||
                src.includes("http://")
              ) {
                src = src.substring(src.indexOf("images/"));
                console.log(src);
                // 拼接 oss 前綴
                imgs[i].src = util.getImageUrl(src);
              }
            }
          }
          describeText = div.innerHTML;
        }
      }
      return describeText;
    },
    /**
     * * 獲取圖片真實寬高
     * @param {*} imageSrc
     * @returns
     */
    getImageDimensions(imageSrc) {
      let src = util.getImageUrl(imageSrc);
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          const width = img.width;
          const height = img.height;
          const aspectRatio = width / height;
          resolve({ width, height, aspectRatio });
        };
        img.onerror = function (e) {
          console.error(e);
        };
        img.src = src;
      });
    },
  },
  history: {
    changeURLArg() {
      function changeURLArg_(arg, arg_val) {
        let url = location.href;
        let pattern = arg + "=([^&]*)";
        let replaceText = arg + "=" + arg_val;
        if (url.match(pattern)) {
          let tmp = "/(" + arg + "=)([^&]*)/gi";
          tmp = url.replace(eval(tmp), replaceText);
          return tmp;
        } else {
          if (url.match("[?]")) {
            return url + "&" + replaceText;
          } else {
            return url + "?" + replaceText;
          }
        }
      }
      let unformatStr = changeURLArg_("t", "1");
      if (!!(window.history && history.pushState)) {
        history.replaceState(null, "", unformatStr);
      }
    },
  },
  goOther: {
    host(port) {
      if (
        location.host.includes("192.") ||
        location.host.includes("localhost") ||
        location.host.includes("127.")
      )
        return `http://${location.hostname}:${port}`;
      else return "";
    },
    embed(router, type = 1) {
      if (type == 1)
        window.location.href = `${this.host(8660)}/embed/${router}`;
      else window.location.replace(`${this.host(8660)}/embed/${router}`);
    },
    activities(router, arg) {
      window.location.href = `${this.host(9601)}/activities/${router}/${arg}`;
    },
  },
  restaurant: {
    /**
     * 根據 餐廳id 獲取 餐廳詳情
     * @param {*} restaurantId
     */
    getByRestaurantId(restaurantId) {
      return new Promise((a, b) => {
        if (!restaurantId) {
          a({});
        } else {
          getShop({
            restaurantId: restaurantId,
          })
            .then((res) => {
              if (res.success) {
                a(res.data);
              } else a({});
            })
            .catch(() => {
              a({});
            });
        }
      });
    },

    // * 查詢品牌下 餐廳列表
    getRestaurantInfoAtlasFun(obj) {
      // * 為避免重複請求, 這裡將數據存起來
      let key_start = `${obj.brandId || obj.restaurantId}_atlas_list`;
      const key = `${key_start}_${window.btoa(
        JSON.stringify(obj)
      )}_${util.time.format(8)}`;
      // let loca_restaurant = localStorage.getItem(key);
      // if (loca_restaurant) {
      //   return new Promise((a, b) => {
      //     a(JSON.parse(loca_restaurant));
      //   });
      // }
      // // * 把之前的刪除
      // for (let key in localStorage) {
      //   if (key.includes(key_start)) {
      //     localStorage.removeItem(key);
      //   }
      // }
      // ? 需要排序
      // ? 先根據營業狀態 分組. 再將營業中的 排序
      const getStatus = (openStatus) => {
        if (openStatus == 0) {
          // 商戶休息中
          return { t: i18n.t('common.Shop_closed'), f: true };
        } else if (openStatus == 2) {
          // 商戶繁忙 不可接單
          return {
            t: i18n.t('common.Shop_in_Busy_delivery_service_not_available_in_this_moment'),
            f: true,
          };
        } else if (openStatus == 4) {
          return {
            t: i18n.t('common.Service_not_available_at_the_moment_please_contact_the_merchant'),
            f: true,
          };
        }
        return {
          t: i18n.check("營業中", "Open", "营业中"),
          f: false,
        };
      };

      // * 如果沒有品牌id && 沒有餐廳id, 則返回空
      if (!obj.brandId && !obj.restaurantId) {
        return Promise.resolve({
          serviceOpen: [],
          serviceClose: [],
          open: [],
          close: [],
        });
      }

      return new Promise((resolve, b) => {
        getRestaurantInfoAtlas(obj)
          .then((res) => {
            const { success, data } = res;
            if (success) {
              // * 服務開了
              let serviceOpen = [];
              // * 服務沒開
              let serviceClose = [];
              // * 營業中
              let open = [];
              // * 非營業中
              let close = [];

              // * 根據 服務開啟狀態, 根據 排序
              for (let i = 0; i < data.length; i++) {
                let item = data[i];
                // * 表示服務開啟了
                if (
                  (obj.type == 1 && item.ziquService == 1) ||
                  (obj.type == 2 && item.menuService == 1)
                ) {
                  serviceOpen.push(item);
                } else serviceClose.push(item);
              }
              for (let i = 0; i < data.length; i++) {
                let item = data[i];
                let status = getStatus(item.openStatus);
                item.status = status;
                if (status.f || !item.mapX) {
                  close.push(item);
                } else {
                  open.push(item);
                }
              }

              // * 如果，沒有 mapX 和 mapY , 則需要根據id排序
              if (!obj.mapX && !obj.mapY) {
                open.sort((a, b) => {
                  return a.id - b.id;
                });
                close.sort((a, b) => {
                  return a.id - b.id;
                });
              }

              let resultJson = {
                serviceOpen: serviceOpen,
                serviceClose: serviceClose,
                open: open,
                close: close,
              };
              // localStorage.setItem(key, JSON.stringify(resultJson));
              resolve(resultJson);
            } else
              resolve({
                serviceOpen: [],
                serviceClose: [],
                open: [],
                close: [],
              });
          })
          .catch(() => {
            resolve({
              serviceOpen: [],
              serviceClose: [],
              open: [],
              close: [],
            });
          });
      });
    },
  },
  system: {
    isM() {
      return location.origin.includes("https://m.ricepon.com");
    },
    // * 切换大字版小字版
    checkMode(type) {
      if (type == "def") {
        document.body.classList.remove("max");
        document.body.classList.add("def");
      } else {
        document.body.classList.remove("def");
        document.body.classList.add("max");
      }
    },
  },
  // 對象
  object: {
    /**
     * 深複製
     * @param {*} obj
     * @returns
     */
    deepClone(obj) {
      if (obj === null || typeof obj !== "object") {
        return obj;
      }
      if (Array.isArray(obj)) {
        const newArray = [];
        for (let i = 0; i < obj.length; i++) {
          newArray[i] = this.deepClone(obj[i]);
        }
        return newArray;
      }
      const newObj = {};
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          newObj[key] = this.deepClone(obj[key]);
        }
      }
      return newObj;
    },
  },
  // ? 传入 中文<br/>en 格式, 转为 {hk,en,cn}
  checkStrByBr(str) {
    let [hk, en, cn] = str.split("  ");
    return {
      hk,
      en,
      cn,
    };
  },
};
export default util;
